import type { ServiceStatus } from './AppTypes';

export function statusLabel(status: ServiceStatus): string {
	switch (status) {
		case 'operational':
			return 'Operational';
		case 'degraded':
			return 'Degraded Performance';
		case 'partial_outage':
			return 'Partial Outage';
		case 'major_outage':
			return 'Major Outage';
		case 'maintenance':
			return 'Under Maintenance';
		default:
			return 'Unknown';
	}
}

/** Big banner headline for the overall page status. */
export function overallHeadline(status: ServiceStatus): string {
	switch (status) {
		case 'operational':
			return 'All Systems Operational';
		case 'degraded':
			return 'Degraded Performance';
		case 'partial_outage':
			return 'Partial System Outage';
		case 'major_outage':
			return 'Major System Outage';
		case 'maintenance':
			return 'Scheduled Maintenance';
		default:
			return 'Status Unknown';
	}
}

/** Tailwind background color for a banner / solid fill. */
export function statusBg(status: ServiceStatus): string {
	switch (status) {
		case 'operational':
			return 'bg-green-500';
		case 'degraded':
			return 'bg-amber-400';
		case 'partial_outage':
			return 'bg-orange-500';
		case 'major_outage':
			return 'bg-red-500';
		case 'maintenance':
			return 'bg-blue-500';
		default:
			return 'bg-gray-400';
	}
}

/** Tailwind text color for a status label. */
export function statusText(status: ServiceStatus): string {
	switch (status) {
		case 'operational':
			return 'text-green-600 dark:text-green-400';
		case 'degraded':
			return 'text-amber-600 dark:text-amber-400';
		case 'partial_outage':
			return 'text-orange-600 dark:text-orange-400';
		case 'major_outage':
			return 'text-red-600 dark:text-red-400';
		case 'maintenance':
			return 'text-blue-600 dark:text-blue-400';
		default:
			return 'text-gray-500 dark:text-gray-400';
	}
}

/** Fill color for a single uptime bar (hex, used in SVG). */
export function statusFill(status: ServiceStatus): string {
	switch (status) {
		case 'operational':
			return '#22c55e';
		case 'degraded':
			return '#fbbf24';
		case 'partial_outage':
			return '#f97316';
		case 'major_outage':
			return '#ef4444';
		case 'maintenance':
			return '#3b82f6';
		default:
			return '#d1d5db';
	}
}

export function impactLabel(impact: string): string {
	return impact.charAt(0).toUpperCase() + impact.slice(1);
}

export function formatDateTime(value: string | null): string {
	if (!value) return '';
	return new Date(value).toLocaleString();
}
